import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SessionService } from '../services/session.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(private sessionService: SessionService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Auth is handled entirely via HttpOnly cookies (EPMS_JSESSION + EPMS_BIND)
    // set by getContextBody/resumePayment. No sessionid header needed.
    request = request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache'
      }
    });

    return next.handle(request)
      .pipe(catchError((err) => {
        if (err.status === 408) {
          if (this.sessionService.startCheckingSessionExpiry) {
            this.sessionService.sessionExpiredSubject.next(true);
          }
        }
        return throwError(err);
      }))
      .pipe(map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
        // Guard against null body crash on empty responses
        if (evt instanceof HttpResponse && evt.body === null) {
          return evt.clone({ body: {} });
        }
        return evt;
      }));
  }
}